import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnInit {

  @Input() image='';
  @Input() bannerTitle=''
  @Input() bannerSubHeading='';
  @Input() bannerDescription='';
  @Input() additionalStyles:any;
  @Input() bannerTextStyles:any;

  constructor() { }

  ngOnInit(): void {
  }

}
